// extracted by mini-css-extract-plugin
module.exports = {"pay":"Charges_pay__3vUBP"};